import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68447539"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channels" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "public")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "org"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "domain", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "filled",
    class: "chatbot",
    clickable: "",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, _toDisplayString(_ctx.chatbot.name), 1),
      _createElementVNode("h4", null, _toDisplayString(_ctx.chatbot.id), 1),
      _hoisted_1,
      (_ctx.chatbot.organization)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", null, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.chatbot.organization), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}